import styled from "@emotion/styled";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { shouldDisplayError } from "helpers/final-form";
import { withVar } from "themes/helpers";

import { fieldErrorCss } from "./styled";

const InputWrapper = styled.span`
  position: relative;
  display: block;

  input {
    line-height: 18px;
    border-radius: 4px;
    border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    padding: 10px;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor80
    };
    width: 100%;
    box-sizing: border-box;
    transition: border 0.25s ease-in-out;
    will-change: border-color;

    &:disabled {
      cursor: default;
      background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
      opacity: 0.6;
    }

    &:focus {
      outline: none;
      border-color: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.activeBorderColor
      };
    }

    ::placeholder {
      opacity: 0.3;
    }
  }

  span.field-error {
    ${fieldErrorCss};
    display: block;
  }
`;

export interface IInputProps {
  name: string; // eslint-disable-line no-restricted-globals
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e?: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e?: React.FocusEvent<HTMLInputElement>) => void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
}

export interface IInputCustomProps {
  type: "text" | "password";
  placeholder?: string;
  fieldRef?(ref: HTMLInputElement): void;
  className?: string;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta?: any;
}

export const Input: React.FC<IInputProps & IInputCustomProps> = ({
  type,
  className,
  fieldRef,
  meta,
  ...otherProps
}) => (
  <InputWrapper className={className}>
    <input type={type} ref={fieldRef} {...otherProps} />
    {shouldDisplayError(meta) && <span className="field-error">{meta.error}</span>}
  </InputWrapper>
);

/**
 * Wrapper for `final-form` Field support
 */
export const InputFieldRender: React.FC<FieldRenderProps<string, HTMLInputElement> & IInputCustomProps> = ({
  input,
  meta,
  ...customProps
}) => <Input {...input} meta={meta} {...customProps} />;
